export default __webpack_public_path__ + "static/media/travel.436aef8b.svg";